import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    // Check URL params for active_tab (used after section save to keep tab active)
    const params = new URLSearchParams(window.location.search)
    const activeTab = params.get("active_tab")

    if (activeTab) {
      const targetTab = this.tabTargets.find(tab => tab.dataset.tab === activeTab)
      if (targetTab) {
        this.show({ currentTarget: targetTab })
        return
      }
    }

    // Activate the first visible (non-hidden) tab
    const firstTab = this.tabTargets.find(tab => {
      const panel = this.panelTargets.find(p => p.dataset.tab === tab.dataset.tab)
      return panel !== undefined
    })

    if (firstTab) {
      this.show({ currentTarget: firstTab })
    }
  }

  show(event) {
    const selectedTab = event.currentTarget
    const tabId = selectedTab.dataset.tab

    // Toggle sidebar tab styles
    this.tabTargets.forEach(tab => {
      if (tab === selectedTab) {
        tab.classList.add("bg-primary/10", "text-primary")
        tab.classList.remove("text-text-secondary", "hover:bg-surface-secondary")
      } else {
        tab.classList.remove("bg-primary/10", "text-primary")
        tab.classList.add("text-text-secondary", "hover:bg-surface-secondary")
      }
    })

    // Toggle panel visibility
    this.panelTargets.forEach(panel => {
      if (panel.dataset.tab === tabId) {
        panel.classList.remove("hidden")
        panel.dispatchEvent(new CustomEvent("mermaid:render", { bubbles: true }))
      } else {
        panel.classList.add("hidden")
      }
    })
  }
}
